import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../components/Header";
import { useAnalytics } from "../lib/analytics";
import { useClientTranslations } from "../lib/i18n/client";
import styles from "./SupportSettings.module.css";

const SUPPORT_EMAIL = "support@eraborn.co";

export function SupportSettings() {
	const { t, direction } = useClientTranslations("profile");
	const { logProfile } = useAnalytics();
	const navigate = useNavigate();

	useEffect(() => {
		logProfile("support_settings_page_viewed");
	}, [logProfile]);

	return (
		<div className={styles.wrapper}>
			<Header />
			<main className={styles.main} dir={direction}>
				<div className={styles.container}>
					<div className={styles.heading}>
						<button
							type="button"
							className={styles.backButton}
							onClick={() => {
								logProfile("support_back_clicked");
								navigate("/settings");
							}}
							aria-label={t("settings.back")}
						>
							&#8249;
						</button>
						<h1 className={styles.title}>{t("settings.cards.support")}</h1>
						<p className={styles.subtitle}>{t("settings.supportSubtitle")}</p>
					</div>

					<div className={styles.content}>
						<p className={styles.text}>
							{t("settings.supportText")}{" "}
							<a
								href={`mailto:${SUPPORT_EMAIL}`}
								className={styles.emailLink}
								onClick={() => {
									logProfile("support_email_clicked", {
										email: SUPPORT_EMAIL,
									});
								}}
							>
								{SUPPORT_EMAIL}
							</a>
						</p>
						<p className={styles.text}>{t("settings.supportResponseTime")}</p>
					</div>
				</div>
			</main>
		</div>
	);
}
